import React, { Component, Fragment } from 'react';
import { ErrorMessage, Field, Form, Formik } from 'formik';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import CustomLoader from '../common/CustomLoader';
import { iconForField } from '../../common/custom/icon-library';
import { getActionEnableSchema } from './ActionFormUtils';
class ActionEnableForm extends Component {
  static propTypes = {
    events: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
    projectId: PropTypes.string.isRequired,
  };

  createActionSettingsSchema = (eventAction) => {
    const { events } = this.props;
    const { projectDetail } = events;
    const { environments } = projectDetail ? projectDetail : {};
    const { defaultEnabled, enabledEnvironments } = eventAction ? eventAction : '';

    let schema = {};
    if (!defaultEnabled) {
      environments.map((environment) => {
        schema[environment.envType] = !!(
          enabledEnvironments &&
          enabledEnvironments.length &&
          enabledEnvironments.includes(environment.envType)
        );
      });
    } else if (environments && environments.length) {
      environments.map((environment) => {
        schema[environment.envType] = true;
      });
    }
    return schema;
  };

  createEnvironmentsField = (envField, setFieldValue, setFieldTouched, values, action) => {
    return (
      <div className="form-group" key={envField.name}>
        <div className="input-group">
          <div className="input-group-prepend" title={envField.label}>
            <span className="input-group-text">
              <i className={`wb ${iconForField(envField.type + '-toggle')}`}></i>
            </span>
          </div>
          <div className="form-check">
            <label className="form-check-label">
              <Field
                type="checkbox"
                name={envField.name}
                className="form-check-input"
                title={envField.name}
              />
              {envField.label}
              <span className="form-check-sign">
                <span className="check"></span>
              </span>
            </label>
            <ErrorMessage name={envField.name}>
              {(msg) => <p className="text-error">{msg}</p>}
            </ErrorMessage>
          </div>
        </div>
      </div>
    );
  };

  renderFormFields = (setFieldValue, setFieldTouched, values, action) => {
    const formField = [];
    const { events } = this.props;
    const { projectDetail } = events;
    const { environments } = projectDetail ? projectDetail : '';
    environments &&
      environments.length &&
      environments.map((environment) => {
        let envField = {
          name: environment.envType,
          label: `${environment.name} (${environment.envType})`,
          type: 'boolean',
        };
        formField.push(
          this.createEnvironmentsField(envField, setFieldValue, setFieldTouched, values, action),
        );
      });

    return formField;
  };

  handleSubmit = (values) => {
    const { events, eventAction, projectId, actions, version } = this.props;
    const { selectedEvent } = events ? events : '';
    const eventId = selectedEvent ? selectedEvent.uuid : '';
    const enabledEnvironments = [];

    values &&
      Object.entries(values)
        .filter(([key, value]) => !!value)
        .map(([key, value]) => {
          enabledEnvironments.push(key);
        });

    if (projectId && eventId) {
      actions.enableAction({
        version,
        projectId: projectId,
        eventId: eventId,
        actionId: eventAction.uuid,
        enabledEnvironments: enabledEnvironments,
      });
    }

    this.props.hideModal();
  };

  render() {
    const { eventAction, actionData } = this.props;
    return (
      <Fragment>
        <div className="mb-4">
          <p>
            <i className="wb webconnect-info-circle-fill"></i>&nbsp;
            {eventAction.defaultEnabled
              ? `Enabled (by default), If you wish to disable this
            action for any specific environment, please uncheck its box.`
              : `This action will be enabled for the selected environments.`}
          </p>
        </div>

        <Formik
          enableReinitialize={true}
          initialValues={this.createActionSettingsSchema(eventAction)}
          onSubmit={(values, { setSubmitting, resetForm }) => {
            this.handleSubmit(values);
            setSubmitting(false);
            resetForm();
          }}
        >
          {({ isSubmitting, values, setFieldValue, setFieldTouched, errors }) => (
            <Form>
              <div className="row">
                <div className="col-12">
                  {this.renderFormFields(setFieldValue, setFieldTouched, values, actionData)}
                </div>
              </div>
              <div className="row">
                <div className="col-12">
                  <div className="text-right">
                    <div className="float-left">
                      <button
                        type="button"
                        className="btn btn-outline-secondary btn-sm"
                        onClick={this.props.hideModal}
                      >
                        <span>
                          <i className="wb webconnect-times"></i> Cancel
                        </span>
                      </button>
                    </div>
                    <div className="float-right">
                      <button type="submit" className="btn btn-theme-submit btn-sm">
                        <i className="wb webconnect-save-regular"></i>&nbsp;Save&nbsp;
                        <CustomLoader loading={this.props.showLoaderForEnableAction} />
                      </button>
                    </div>
                    <div className="clearfix"></div>
                  </div>
                </div>
              </div>
            </Form>
          )}
        </Formik>
      </Fragment>
    );
  }
}

// function getActionEnableSchema(events, eventAction) {
//   const { project } = events ? events : '';
//   const { environments } = project ? project : '';
//   const { defaultEnabled, enabledEnvironments } = eventAction ? eventAction : '';
//   console.log(
//     '🚀 ~ file: ActionEnableForm.js:21 ~ ActionEnableForm ~ defaultEnabled:',
//     defaultEnabled,
//     ' ~ enabledEnvironments:',
//     enabledEnvironments
//   );

//   let schema = {};
//   if (!defaultEnabled) {
//     environments.map((environment) => {
//       schema[environment.envType] = !!(
//         enabledEnvironments &&
//         enabledEnvironments.length &&
//         enabledEnvironments.includes(environment.envType)
//       );
//     });
//   } else if (environments && environments.length) {
//     environments.map((environment) => {
//       schema[environment.envType] = true;
//     });
//   }
//   console.log('🚀 ~ file: ActionEnableForm.js:40 ~ ActionEnableForm ~ schema:', schema);
//   return schema;
// }

function mapStateToProps(state) {
  return {
    event: state.event,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ActionEnableForm);
